<template>
  <div class="search-results">
    <NavBar />
    <div class="container">
      <h2>"{{ schoolName }}"的所有学院</h2>

      <div v-if="loading" class="loading">加载中...</div>

      <div v-else>
        <div v-if="colleges.length === 0" class="no-results">
          该学校暂无学院信息
        </div>

        <div v-else class="college-list">
          <div
              v-for="college in colleges"
              :key="college.id"
              class="college-card"
          >
            <h3>{{ college.name }}</h3>
            <p>教授数量: {{ college.professorCount }}</p>
            <router-link
                :to="{ name: 'ProfessorSearchResults', query: { school: schoolName, department: college.name } }"
                class="view-detail"
            >
              查看该学院所有教授
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import BlogFooter from '@/components/BlogFooter.vue'
import axios from 'axios'

export default {
  name: 'SchoolSearchResults',
  components: { NavBar, BlogFooter },
  data() {
    return {
      schoolName: '',
      colleges: [],
      loading: true
    }
  },
  created() {
    this.schoolName = this.$route.query.q || ''
    this.fetchSchoolColleges()
  },
  methods: {
    async fetchSchoolColleges() {
      try {
        const response = await axios.get('/api/schools/colleges', {
          params: {
            school_name: this.schoolName
          }
        })
        this.colleges = response.data
      } catch (error) {
        console.error('获取学院信息失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.search-results {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.loading, .no-results {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
}

.college-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.college-card {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.view-detail {
  display: inline-block;
  margin-top: 1rem;
  color: #3498db;
  text-decoration: none;
}

.view-detail:hover {
  text-decoration: underline;
}
</style>